import type { ReactNode } from 'react'

import { useToast } from '@/src/general/components/ToastContext'
import { ICON } from '@/src/general/enums/icons'
import { useSearchParamsAction } from '@/src/general/hooks/useSearchParamsAction'
import { parseApiError } from '@/src/general/utilities/fetcher/parseApiError'
import { useTranslate } from '@/src/lang/useTranslate'

import { useBecomeWatchman } from '../../services/useBecomeWatchman'
import { useWatchman } from '../../services/useWatchman'

export const WatchmanSearchParams = ({ searchParams }: TSearchParamsParam): ReactNode => {
  const { isWatchman } = useWatchman()
  const { mutateAsync } = useBecomeWatchman()
  const { t } = useTranslate()
  const { addToast } = useToast()
  useSearchParamsAction({
    searchParams,
    action: () => {
      mutateAsync().catch((error) => {
        addToast({ message: t(parseApiError(error) || 'common.error.unknown'), colors: 'danger', iconName: ICON.CROSS })
      })
    },
    requestedQuery: !isWatchman ? { action: 'subscribe-watchman' } : null,
  })

  return null
}
